import { useTranslation } from 'react-i18next';

import { WebcastSetupPage } from './webcast-setup';
import { ErrorPage } from '../../../components/error-page';
import { useCurrentUserRolesForWebcast } from '../../hooks/use-current-user-roles-for-webcast';
import { useUserPermissions } from '../../hooks/user-permissions';

import accessDeniedOperatorImage from '../../../assets/access-denied-operator.svg';

export function WebcastGuard() {
  const { t } = useTranslation();
  const { isAccessToEventSetupAllowed, isAdminUser } = useUserPermissions();
  const { isOnlyModeratorForEvent } = useCurrentUserRolesForWebcast();

  if (!isAccessToEventSetupAllowed || (isOnlyModeratorForEvent && !isAdminUser)) {
    return (
      <ErrorPage
        data-testid="access-denied"
        title={t('common.accessDenied.title')}
        subTitle={t('common.accessDenied.subTitle')}
        image={accessDeniedOperatorImage}
        style={{ gridArea: 'section', height: 'unset', background: 'none' }}
      />
    );
  }

  return <WebcastSetupPage />;
}
